<template>
    <div>
        <p>{{ answer }}</p>
    </div>
</template>

<script>
import { getOptionAnswer } from "./questions";

export default {
    name: "radio-question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        answer() {
            let answer = getOptionAnswer(this.question);
            return answer ?? "-";
        },
    },
};
</script>